import * as React from "react";
import { Button } from "@blueprintjs/core";
import { VeterinaryGridDto, VeterinaryClinicApi, AvailableVeterinaryForClinicSearch } from "../../../../api";
import { SearchTablePage } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { useGlobalData } from "../../../../contexts";
import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { useParams } from "react-router";

export interface IClinicVeterinariesSelectorPanelProps {
  onVeterinarySelected: (veterinary: VeterinaryGridDto) => void;
}

export const ClinicVeterinariesSelectorPanel: React.FunctionComponent<IClinicVeterinariesSelectorPanelProps> = (
  props
) => {
  const api = useApiService(VeterinaryClinicApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const { id } = useParams<{ id: string }>();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: VeterinaryGridDto) => (
          <ButtonContainer>
            <Button onClick={() => props.onVeterinarySelected(row)} text={t(ETLCodes.Select)} />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: VeterinaryGridDto) => `${row.name}`,
      },
    ],
    [props, t]
  );

  const search = React.useCallback(
    (sObj) =>
      api.getAvailableVeterinaryForClinic(
        AvailableVeterinaryForClinicSearch.fromJS({
          ...sObj,
          clinicId: +id,
          languageId: currentLanguage.languageId,
        })
      ),
    [api, currentLanguage.languageId, id]
  );

  return (
    <div>
      <SearchTablePage
        columns={columns}
        searchFunction={search}
        sortKeys={{ VeterinaryId: "ASC" }}
        withCard={false}
        breadCrumbs={[{ text: t(ETLCodes.Veterinarians) }]}
      />
    </div>
  );
};
